import { IGibiLocationCommand, IPoint } from '../interfaces/types'

/**
 * Determines whether a location report's GPS coordinates can be trusted.
 *
 * Logic:
 * - If `locationValid` is present (new reports), use it directly.
 * - If `locationValid` is absent (legacy reports), fall back to status:
 *   status 1 or 2 = valid, status 0 = invalid.
 */
export const isLocationValid = (props: IGibiLocationCommand | undefined): boolean => {
    if (!props) return false
    if (typeof props.locationValid === 'boolean') return props.locationValid
    // Legacy fallback: status 1 (GPS fix) and status 2 (no motion) are considered valid
    return props.status === 1 || props.status === 2
}

/** Convenience wrapper that accepts an IPoint directly. */
export const isPointLocationValid = (point: IPoint | undefined): boolean => {
    return isLocationValid(point?.properties)
}

/** Returns true if this is a "no motion" report (status === 2). */
export const isNoMotionReport = (props: IGibiLocationCommand | undefined): boolean => {
    return props?.status === 2
}
